import * as yup from 'yup';

export const validationSchema = yup.object({
	city: yup
		.string()
		.min(2, 'City should be of minimum 2 characters length')
		.required('City is required'),
	address: yup.string().min(2).required('Address is required'),
	iossProjectId: yup
		.string()
		.matches(/^[0-9]+$/, 'Must be only digits')
		.min(4, 'IOSS Project ID should be of minimum 4 characters length')
		// .required('IOSS Project ID is required'),
		.notRequired(),
	ddpProjectId: yup
		.string()
		.matches(/^[0-9]+$/, 'Must be only digits')
		.min(4, 'DDP Project ID should be of minimum 4 characters length')
		// .required('DDP Project ID is required'),
		.notRequired(),
	zipCode: yup
		.string()
		.matches(/^[0-9]+$/, 'Must be only digits')
		.min(4, 'Zip Code should be of minimum 4 digits')
		.max(5, 'Zip Code should be of maximum 5 digits')

		.required('Zip Code is required'),
	defaultHs6Code: yup
		.string()
		.matches(/^[0-9]+$/, 'Must be only digits')
		.min(8, 'Default HS code should be of minimum 8 characters length')
		.max(10, 'Default HS code should be of maximum 10 characters length')
		// .required('Default HS6 code is required'),
		.notRequired(),
	frankingLicense: yup.string().min(2, 'Franking License is required'),
	swissFirstMileClientId: yup.string().min(2, 'Swiss First Mile Client ID is required'),
	swissFirstMileClientSecret: yup.string().min(2, 'Swiss First Mile Client Secret is required'),
});
